import _ 				from "lodash";

import Service 			from "./../../Libs/Service";

import { Server } 		from "./Server";
import { Layout } 		from "./Layout";
import { Auth } 		from "./Auth";
import { Cluster } 		from "./Cluster";
import { User }			from "./User";
import { Version }		from "./Version";
import { Notifications } from "./Notifications";
import Broadcast from "../../Libs/Broadcast";

let Creative = new Service({

	Name: "Creative",

	Libraries: [],

	Events: {

		//Переключение рабочей ноды: активные карты данных подменяются картами этой ноды
		"Cluster Working Node Changed": function(previousServerId, serverId) {

			this.useServer(serverId);

		},

		"Clone Creative Done": function(creative_id) {

			this.selectCreative(creative_id);

		},

		"Creative Versions Loaded": function(creativeId) {

			this.markCreativePartAsLoaded(creativeId, "versions");

		},

		"Creative Localization Loaded": function(creativeId) {

			this.markCreativePartAsLoaded(creativeId, "localization");

		},

		"Creative Assets Loaded": function(creativeId) {

			this.markCreativePartAsLoaded(creativeId, "assets");

		},

		"Creative Assets Original Loaded": function(creativeId) {

			this.markCreativePartAsLoaded(creativeId, "assets-original");

		},

		"Creative Screens Loaded": function(creativeId) {

			this.markCreativePartAsLoaded(creativeId, "screens");

		},

		"Creative Events Loaded": function(creativeId) {

			this.markCreativePartAsLoaded(creativeId, "events");

		},

		"Creative Elements Loaded": function(creativeId) {

			this.markCreativePartAsLoaded(creativeId, "elements");

		},

		"Creative Animations Loaded": function(creativeId) {

			this.markCreativePartAsLoaded(creativeId, "animations");

		},

		"Creative Animation Steps Loaded": function(creativeId) {

			this.markCreativePartAsLoaded(creativeId, "animation-steps");

		},

		"Creative Emitters Loaded": function(creativeId) {

			this.markCreativePartAsLoaded(creativeId, "emitters");

		},

		"Current User Changed,Current User Loaded": function() {

			if (!User.currentUser) {

				//Пользователь вышел: данные креативов всех нод больше не нужны
				this.CreativesByServer = {};
				this.loadedCreativesByServer = {};
				this.CreativesIconsTimesByServer = {};
				this.AIBudgetsByServer = {};
				this.AIBudgetLogsByServer = {};
				this.AvailableAIBudgetsByServer = {};
				this.aiCodeEditActivatingCreativesByServer = {};

				//Возвращаем рабочую ноду в исходное состояние: следующий вход заново выберет
				//ноду аккаунта и разложит данные по её картам
				Cluster.useServer(0);

				//Активные карты заново берём из (уже пустых) карт рабочей ноды
				this.NodeServerId = null;
				this.useServer(0);

			}

		},
		"Layout Page Showed:banners,Layout Page Showed:playables,Layout Page Showed:end-cards,Layout Page Showed:storyboards,Layout Page Showed:editable-playables,Layout Page Showed:marker": function() {

			this.autoSelectCreative();

		}

	},

	Actions: {

		//Получение креативов текущего издателя (serverId - нода, с которой пришли данные)
		"Creatives": function(creatives, data, size, serverId) {

			//Паблишер может прийти в самих креативах, а может - в данных сообщения (CreativesPublisherId):
			//креативы хранятся по паблишеру, поэтому без него креатив некуда положить
			let payloadPublisherId = parseInt(data.CreativesPublisherId, 10) || 0;

			_.each(creatives, (creative, creativeId) => {

				if (!creative) return this.removeCreative(parseInt(creativeId), serverId);

				let publisherId = creative["publisher_id"] ? creative["publisher_id"] : payloadPublisherId;

				this.setCreative(parseInt(creativeId), creative, publisherId, serverId);

			});

			this.loaded = true;

			if (!Creative.SelectedCreative || payloadPublisherId) this.autoSelectCreative();

			if (payloadPublisherId) Broadcast.call("Publisher Creatives Loaded", [payloadPublisherId]);
			else Broadcast.call("Creatives Loaded", []);

		},

		"NewCreativeCreated": function(creativeId, data) {

			if (data["CreateUserId"] === User.currentUser.id) {

				this.selectCreative(creativeId);

				let creative = this.getCreative(creativeId);

				if (creative?.type === 'banner') {

					Version.selectVersion(null);
					Broadcast.call("Show BannerCreateVersion");

				} else if (creative?.type === 'storyboard') {

					Version.selectVersion(null);
					Broadcast.call("Show StoryboardCreateVersion");

				} else if (creative?.type === 'editable-playable') {

					Version.selectVersion(null);
					Broadcast.call("Show EditablePlayableCreateVersion");

				}

			}

		},

		// Сервер начал / закончил создание копии креатива для редактирования кода ИИ агентом
		"AICodeEditActivationState": function(data) {

			if (data.processing) this.aiCodeEditActivatingCreatives[data.creativeId] = true;
			else delete this.aiCodeEditActivatingCreatives[data.creativeId];

			Broadcast.call("AI Code Edit Activation State Changed", [data.creativeId]);

		},

		// Копию креатива для редактирования кода ИИ агентом создать не удалось (или превышено ограничение частоты)
		"AICodeEditActivationError": function(data) {

			Notifications.showError(data.error);

		},

		"CreativeIconChanged": function(creative_id, data, size, serverId) {

			this.getServerMap(this.CreativesIconsTimesByServer, serverId || this.NodeServerId)[creative_id] = Date.now();

			Broadcast.call("Creatives Icons Changed")

		},

		"CreativeDownloadLink": function(data) {

			if (data.releaseType) {

				Monitoring.unsetProcess({type: "release-build", name: `${data.versionId}-${data.releaseType}`});

			} else if (data.releasesTypes) {

				data.releasesTypes.forEach(releaseType => {

					Monitoring.unsetProcess({type: "release-build", name: `${data.versionId}-${releaseType}`});

				});

			}

			window.open(data.link, "blank");

		},

		"CreativeDownloadFailed": function(data) {

			Monitoring.setProcessError({type: "release-build", name: `${data.versionId}-${data.releaseType}`}, data);

		},

		// ИИ бюджет креатива (приходит только паблишер-админам паблишера креатива и супер-админам)
		"CreativeAIBudget": function(creativeAIBudget, data, size, serverId) {

			this.getServerMap(this.AIBudgetsByServer, serverId || this.NodeServerId)[creativeAIBudget.id] = creativeAIBudget;

			Broadcast.call("Creative AI Budget Changed", [creativeAIBudget.id]);

		},

		// Список изменений ИИ бюджета креатива (добавления, отнимания и переводы, новые сверху)
		"CreativeAIBudgetLog": function(creativeAIBudgetLog, data, size, serverId) {

			this.getServerMap(this.AIBudgetLogsByServer, serverId || this.NodeServerId)[creativeAIBudgetLog.creativeId] = creativeAIBudgetLog.records;

			Broadcast.call("Creative AI Budget Changed", [creativeAIBudgetLog.creativeId]);

		},

		// Доступный текущему пользователю в креативе ИИ бюджет по источникам в порядке траты (Creative.AI.mjs getAvailableAIBudget)
		"AvailableAIBudget": function(availableAIBudget, data, size, serverId) {

			this.getServerMap(this.AvailableAIBudgetsByServer, serverId || this.NodeServerId)[availableAIBudget.creativeId] = availableAIBudget.sources;

			Broadcast.call("Creative AI Budget Changed", [availableAIBudget.creativeId]);

		}

	},

	init() {

		//Карты данных по нодам кластера: у каждой ноды своя БД, и id креативов и паблишеров
		//на разных нодах совпадают, поэтому карты разделены по нодам (Client/Libs/Service.js, getServerMap)
		this.CreativesByServer = {};
		this.loadedCreativesByServer = {};
		this.CreativesIconsTimesByServer = {};
		this.AIBudgetsByServer = {};
		this.AIBudgetLogsByServer = {};
		this.AvailableAIBudgetsByServer = {};
		this.aiCodeEditActivatingCreativesByServer = {};

		this.loaded = false;

		// Названия источников ИИ бюджета в описании доступного бюджета (как на сервере в Creative.AI.mjs)
		// Ключи - значения monitoring_ai_budget.budget_type, поэтому источник креатива остаётся с ключом project
		this.AI_BUDGET_SOURCE_TITLES = {
			user: 'personal budget',
			project: 'creative budget',
			publisher: 'company budget'
		};

		// Текущий креатив
		this.SelectedCreative = null;

		// Активные карты - карты рабочей ноды
		this.useServer(0);

	},

	// Активные карты данных рабочей ноды: при переключении ноды они подменяются ссылками на карты
	// этой ноды, поэтому код обращения к ним (Creatives[publisherId][creativeId]) не меняется
	useServer(serverId) {

		serverId = serverId || 0;

		if (this.NodeServerId === serverId) return;

		this.NodeServerId = serverId;

		this.Creatives = this.getServerMap(this.CreativesByServer, serverId);
		this.loadedCreatives = this.getServerMap(this.loadedCreativesByServer, serverId);
		this.CreativesIconsTimes = this.getServerMap(this.CreativesIconsTimesByServer, serverId || this.NodeServerId);
		this.AIBudgets = this.getServerMap(this.AIBudgetsByServer, serverId || this.NodeServerId);
		this.AIBudgetLogs = this.getServerMap(this.AIBudgetLogsByServer, serverId || this.NodeServerId);
		this.AvailableAIBudgets = this.getServerMap(this.AvailableAIBudgetsByServer, serverId || this.NodeServerId);
		this.aiCodeEditActivatingCreatives = this.getServerMap(this.aiCodeEditActivatingCreativesByServer, serverId);

		//Выбранный креатив остался от прежней ноды: id креативов на разных нодах совпадают,
		//поэтому креатив нужно выбрать заново из карт новой ноды
		this.SelectedCreative = null;

		Broadcast.call("Selected Creative Changed");

	},

	// Ключ localStorage для последнего открытого креатива паблишера: номер ноды обязателен,
	// потому что id паблишеров на разных нодах совпадают
	getStoredCreativeKey(publisher) {

		return `selected-project-id-for-publisher-${publisher.server_id}-${publisher.id}`;

	},

	// Креативы одного паблишера: объект creativeId -> креатив
	getCreativesByPublisher(publisherId) {

		return this.Creatives[publisherId];

	},

	// Все креативы всех паблишеров одним списком
	getAllCreatives() {

		return _.flatten(_.map(this.Creatives, creatives => _.values(creatives)));

	},

	// Креатив по id: креативы активных карт - креативы рабочей ноды
	getCreative(creativeId) {

		let found = null;

		_.each(this.Creatives, creatives => {

			if (!found && creatives[creativeId]) found = creatives[creativeId];

		});

		return found;

	},

	// Относится ли текущий выбранный креатив к указанному паблишеру
	isSelectedCreative(publisher) {

		if (!this.SelectedCreative || !publisher) return false;

		return this.SelectedCreative["publisher_id"] === publisher.id;

	},

	// Нода, с которой пришли данные: явный номер из сообщения сервера, иначе - нода паблишера
	resolveServerId(serverId, publisherId) {

		return serverId || Publisher.getServerIdForPublisher(publisherId);

	},

	setCreative(creative_id, newCreative, publisherId, serverId) {

		//Удаление креатива паблишер не передаёт - ищем креатив по id во всех паблишерах
		if (!newCreative) return this.removeCreative(creative_id, serverId);

		//Креатив кладём в карты ноды, с которой пришли данные: сообщение могло прийти и от ноды,
		//паблишер которой сейчас не открыт (у админа подключены все ноды кластера)
		serverId = this.resolveServerId(serverId, publisherId);

		let creativesByPublisher = this.getServerMap(this.CreativesByServer, serverId);

		if (!creativesByPublisher[publisherId]) creativesByPublisher[publisherId] = {};

		let creatives = creativesByPublisher[publisherId],
			oldCreative = creatives[creative_id];

		creatives[creative_id] = newCreative;

		if (newCreative.options.templatePlayableCodename) newCreative.templateProps = Metadata.TemplatePlayablesByCodename[newCreative.options.templatePlayableCodename];
		if (newCreative.options.endCardId) newCreative.templateProps = Metadata.TemplateEndCards[newCreative.options.endCardId];

		if (!newCreative.options.markers) newCreative.options.markers = [];

		if (typeof newCreative['last_update_timestamp'] === 'string') newCreative['last_update_timestamp'] = new Date(newCreative['last_update_timestamp']).getTime();

		newCreative.engine = 'dom';
		if (newCreative.Tags.pixi) newCreative.engine = 'pixi';
		if (newCreative.Tags.three) newCreative.engine = 'three';

		//Выбранный креатив обновляем, только когда данные пришли с его ноды
		if (serverId === this.NodeServerId && this.SelectedCreative && this.SelectedCreative.id === creative_id) this.SelectedCreative = newCreative;

		this.detectCreativeChanges(creative_id, oldCreative, newCreative);

	},

	// Креатив удалён: удаляем его из карт ноды, которая сообщила об удалении
	removeCreative(creativeId, serverId) {

		serverId = serverId || this.NodeServerId;

		let oldCreative = null;

		_.each(this.getServerMap(this.CreativesByServer, serverId), creatives => {

			if (!oldCreative && creatives[creativeId]) oldCreative = creatives[creativeId];

			if (creatives[creativeId]) delete creatives[creativeId];

		});

		if (serverId === this.NodeServerId && this.SelectedCreative && this.SelectedCreative.id === creativeId) this.SelectedCreative = null;

		//События удаления те же, что и раньше: клиент должен убрать креатив со экрана
		if (oldCreative) this.detectCreativeChanges(creativeId, oldCreative, null);

	},

	detectCreativeChanges(creativeId, oldCreative, newCreative) {

		//Если такой объект креатива уже был на клиенте
		if (oldCreative) {

			//Если объект креатива пролучен
			if (newCreative) {

				if (oldCreative.title !== newCreative.title) {

					if (newCreative["id"] === Creative.SelectedCreative?.id) Broadcast.call("Selected Creative Renamed");
					else Broadcast.call("Creative Renamed", [creativeId]);

				} else if (oldCreative.options.markers.length !== newCreative.options.markers.length) {

					if (newCreative["id"] === Creative.SelectedCreative?.id) Broadcast.call("Selected Creative Markers Changed");
					else Broadcast.call("Creative Markers Changed", [creativeId]);

				} else if (oldCreative.options.iconUrl !== newCreative.options.iconUrl) {

					if (newCreative["id"] === Creative.SelectedCreative?.id) Broadcast.call("Selected Creative Icon Changed");
					else Broadcast.call("Creative Icon Changed", [creativeId]);

				} else if (oldCreative.tags !== newCreative.tags) {

					if (newCreative["id"] === Creative.SelectedCreative?.id) Broadcast.call("Selected Creative Tags Changed");
					else Broadcast.call("Creative Tags Changed", [creativeId]);

				} else {

					if (newCreative["id"] === Creative.SelectedCreative?.id) Broadcast.call("Selected Creative Updated");
					else Broadcast.call("Creative Updated", [creativeId]);

				}

			}

			//Если креатив удалили
			else {

				//Если это выбранный в данный момент креатив
				if (oldCreative["id"] === Creative.SelectedCreative?.id) {

					Broadcast.call("Selected Creative Changed");

				} else {

					Broadcast.call("Creative Changed", [creativeId]);

				}

				Broadcast.call("Creative Deleted", [creativeId]);

			}

		}

		//Если такого объекта креатива ещё не было на клиенте
		else {

			//Если в новых пришедших данных есть объект креатива
			if (newCreative) {

				//Broadcast.call(`Creative Loaded`, [newCreative["version_id"], newCreative.codename]);
				Broadcast.call("Creative Changed", [creativeId]);

			}

			//Если креатив удалили
			else {

				//Тут можно ничего не делаеть. Креатива и так не было, но пришло сообщение что его удалили

			}

		}

	},

	isSelectedCreativeLoaded() {

		if (!this.SelectedCreative) return false;

		return this.loadedCreatives[this.SelectedCreative.id] && this.loadedCreatives[this.SelectedCreative.id].loaded;

	},

	// Помечаем часть креатива как загруженную
	// И проверяем загружены ли все части, если да то помечаем весь креатив как загруженный
	markCreativePartAsLoaded(creativeId, partName) {

		let lp = this.loadedCreatives[creativeId];

		if (!lp) lp = this.loadedCreatives[creativeId] = {};

		lp[partName] = true;

		if (lp["versions"] && lp["assets"] && lp["assets-original"] && lp["localization"] && lp["settings"] && lp["settings-original"] && lp["screens"] && lp["events"] && lp["elements"] && lp["animations"] && lp["animation-steps"] && lp["emitters"]) {

			let oldLoaded = lp.loaded;

			lp.loaded = true;

			if (!oldLoaded) {

				Broadcast.call("Creative Fully Loaded", [creativeId]);

				if (Creative.SelectedCreative && parseInt(creativeId) === Creative.SelectedCreative.id) Broadcast.call("Selected Creative Fully Loaded");
				//else console.log("Creative Fully Loaded but NOT Selected", Creative.SelectedCreative, creativeId);

			}

		}

	},

	selectCreative(creativeId) {

		let creative = this.getCreative(creativeId);

		if (creative) {

			this.SelectedCreative = creative;

			Layout.setCreative(creativeId);

			Broadcast.call("Selected Creative Changed");

			window.localStorage.setItem(this.getStoredCreativeKey(Publisher.SelectedPublisher), creativeId);

		} else {

			this.SelectedCreative = null;

			Broadcast.call("Selected Creative Changed");

		}

	},

	autoSelectCreative() {

		if (!Publisher.SelectedPublisher) return;

		//Возможные креативы этого воркспейса (список уже ограничен выбранным паблишером)
		let creatives = this.getOrderedCreativesList(Publisher.SelectedPublisher, Layout.page, Layout.workspace, Layout.creativesFilter);

		//Последний открытый креатив
		let lastCreativeId = parseInt(window.localStorage.getItem(this.getStoredCreativeKey(Publisher.SelectedPublisher))) || 0;

		//Ищем его среди доступных креативов
		let lastCreative = creatives.find(creative => creative.id === lastCreativeId);

		//Отменяем сброс креатива при переподключении к серверу и смене воркспейса
		if (lastCreative && this.isSelectedCreative(Publisher.SelectedPublisher)) return;

		if (lastCreativeId && lastCreative) return this.selectCreative(lastCreativeId);

		if (creatives[0]) this.selectCreative(creatives[0].id);
		else this.selectCreative(null);

	},

	getOrderedCreativesList(publisher = null, page = null, workspace = null, searchFilter = null) {

		let sortData = {
			type: "create_date",
			order: "desc"
		};

		if (Publisher.SelectedPublisher?.options?.["UI"]?.["projectPlaneIconsSort"]) {
			const iconsSort = Publisher.SelectedPublisher.options["UI"]["projectPlaneIconsSort"];
			if (iconsSort.type) sortData.type = iconsSort.type;
			if (iconsSort.order) sortData.order = iconsSort.order;
		}

		let creatives = this.getAllCreatives();

		if (publisher) creatives = _.filter(creatives, p => p.publisher_id === publisher.id);

		if (page) {

			creatives = _.filter(creatives, p => (page === "playables" && p.type === "playable") || (page === "banners" && p.type === "banner") || (page === "end-cards" && p.type === "end-card") || (page === "storyboards" && p.type === "storyboard") || (page === "editable-playables" && p.type === "editable-playable") || (page === "marker" && _.intersection(_.get(p, `options.markers`), _.get(Layout, "pageOptions.markers")).length > 0));

			if (page !== "marker") creatives = _.filter(creatives, p => !p.options["showOnlyInMarkersMenu"]);

		}

		if (workspace) creatives = _.filter(creatives, p => p.Tags[`workspace-${workspace}`]);

		let creativeWithSearchFilterId;
		if (searchFilter) {

			if (!isNaN(searchFilter.trim())) {
				creativeWithSearchFilterId = _.find(creatives, p => p.id === parseInt(searchFilter.trim()));
			}

			creatives = _.filter(creatives, p => p.title.toLowerCase().indexOf(searchFilter.toLowerCase()) > -1);
		}

		creatives = _.filter(creatives, p => User.currentUser?.Tags?.["admin"] || (!p.Tags["deleted"] && !p.Tags["hidden"]));

		let result = this.orderBy(creatives, sortData.type, sortData.order);
		if (creativeWithSearchFilterId && (User.currentUser?.Tags?.["admin"] || (!creativeWithSearchFilterId.Tags["deleted"] && !creativeWithSearchFilterId.Tags["hidden"]))) result = [creativeWithSearchFilterId].concat(result);

		return result;

	},

	// Доступный текущему пользователю в креативе ИИ бюджет по источникам в порядке траты: [{type: user / creative / publisher, id, amount}].
	// Считается на сервере (Creative.AI.mjs getAvailableAIBudget) и приходит для открытого креатива. null - данные ещё не получены
	getAvailableAIBudget(creative) {

		return (creative && this.AvailableAIBudgets[creative.id]) || null;

	},

	// Описание доступного бюджета по источникам без суммирования, например: "$10.00 (personal budget) + $15.00 (creative budget)".
	// Если тратится только бюджет паблишера креатива (ai_budget_split = 0) - только сумма: "$50.00" (как на сервере в Creative.AI.mjs getAIBudgetDescription)
	// developerTitles - названия источников для админов и супер-админов (разработчиков дашборда): личный бюджет разработчика и ИИ бюджет его паблишера
	// hideEmptyPersonal - не писать личный бюджет пользователя, если он 0 или меньше (остаются только остальные источники)
	getAvailableAIBudgetDescription(creative, developerTitles = false, hideEmptyPersonal = false) {

		let availableAIBudget = this.getAvailableAIBudget(creative);

		if (!availableAIBudget) return null;

		if (hideEmptyPersonal) {

			let withoutEmptyPersonal = _.filter(availableAIBudget, source => !(source.type === 'user' && source.amount <= 0.01));
			if (withoutEmptyPersonal.length) availableAIBudget = withoutEmptyPersonal;

		}

		if (availableAIBudget.length === 1 && availableAIBudget[0].type === 'publisher') return `$${availableAIBudget[0].amount.toFixed(2)}`;

		return _.map(availableAIBudget, source => `$${source.amount.toFixed(2)} (${this.getAIBudgetSourceTitle(source.type, developerTitles)})`).join(' + ');

	},

	// Название источника ИИ бюджета. Для разработчиков дашборда название берётся из конфига (dashboard-domain-title), например "<Название> ai budget"
	getAIBudgetSourceTitle(type, developerTitles = false) {

		let domainTitle = Metadata.Config["dashboard-domain-title"];

		if (developerTitles && type === 'user') return `${domainTitle} developer personal budget`;
		if (developerTitles && type === 'publisher') return `${domainTitle} ai budget`;

		return this.AI_BUDGET_SOURCE_TITLES[type];

	},

	getTitle(creative) {

		let title = creative.title;
		let publisher = Publisher.getPublisher(creative["publisher_id"]);

		if (!publisher) return title;

		if (title.toLowerCase().indexOf(publisher.codename) === 0) title = title.substr(publisher.codename.length + 1);

		return title;

	},

	//Адрес файла креатива (иконка, ассет, превью): файлы лежат на ноде паблишера креатива,
	//а браузер по относительному пути запросил бы их у ноды загрузки клиента
	getFileUrl(creative, path) {

		return Auth.getNodeUrlForServer(Publisher.getServerIdForPublisher(creative['publisher_id']), path);

	},

	orderBy(collection, type, order) {

		if (type === "title") {

			collection.sort((a, b) => {

				let nameA= this.getTitle(a), nameB = this.getTitle(b);

				nameA = nameA.toLowerCase();
				nameB = nameB.toLowerCase();

				if (order === "asc") {
					if (nameA < nameB) return -1;
					if (nameA > nameB) return 1;
					return 0;
				} else if (order === "desc") {
					if (nameA < nameB) return 1;
					if (nameA > nameB) return -1;
					return 0;
				}

			});

			return collection;

		} else return _.orderBy(collection, type, order);

	},

	downloadCreative(type, networkOptions, downloadOptions = {}) {

		Server.sendToSocket({
			DownloadCreative: {
				creativeId: Creative.SelectedCreative.id,
				versionId: Version.SelectedVersion.id,
				releaseType: type,
				releaseSize: Layout.getPreviewSize(),
				networkOptions: networkOptions,
				debugCode: !!downloadOptions.debugCode
			}
		});

		Monitoring.setProcess({type: "release-build", name: `${Version.SelectedVersion.id}-${type}`})

	}

});

window.Creative = Creative;

export { Creative }

